<template>
  <div>
    <v-row>
      <v-col cols="12" md="7" lg="5">
        <h3 class="mb-2">Scholars Result di assessment module</h3>
      </v-col>
      <v-col cols="12" md="2" lg="2">
        <v-btn
          class="text-capitalize"
          @click="exportData"
          height="38px"
          color="white"
        >
          <v-icon color="green">mdi-microsoft-excel</v-icon>
          Export Data
        </v-btn>
      </v-col>
      <v-col cols="12" md="5" lg="5">
        <v-text-field
          placeholder="Search User"
          solo
          v-model="find"
          @keyup="fetchData"
          hide-details
          dense
          :color="color"
          prepend-inner-icon="mdi-magnify"
        ></v-text-field>
      </v-col>
    </v-row>
    <div v-if="dataSet && !loading" min-height="300px">
      <div v-if="dataSet.length">
        <v-expansion-panels>
          <v-expansion-panel
            class="rounded-lg my-2"
            v-for="(item, i) in dataSet"
            :key="`sect_${i}`"
            elevation="1"
          >
            <v-expansion-panel-header class="pa-3">
              <div class="d-flex align-center pa-2">
                <router-link
                  class="opener_name"
                  :to="`/scholar/${item.data.user_id}`"
                >
                  <v-avatar size="40" class="mr-2">
                    <img
                      :src="
                        item.data.profile_picture
                          ? item.data.profile_picture
                          : ava
                      "
                      class="obj_fit"
                      alt="isyan"
                    />
                  </v-avatar>
                </router-link>
                <div>
                  <div class="d-flex align-center">
                    <router-link
                      class="opener_name"
                      :to="`/scholar/${item.data.user_id}`"
                    >
                      <h3 style="color: #006341">{{ item.data.name }}</h3>
                    </router-link>
                    <small
                      class="ml-1 grey--text"
                      style="color: rgba(0, 0, 0, 0.4)"
                    >
                      · {{ $date(item.data.answer_created).fromNow() }}</small
                    >
                    <v-icon color="blue" class="ml-2" v-if="item.data.score"
                      >mdi-check-decagram</v-icon
                    >
                  </div>
                  <p class="default_txt mt-2">
                    {{ item.data.no_tf ? item.data.no_tf : "-" }}
                  </p>
                </div>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div>
                <v-card
                  class="pa-3 d-flex justify-space-between align-center rounded-lg"
                  outlined
                >
                  <div class="d-flex align-center">
                    <v-icon :color="color" size="50"> mdi-note-edit </v-icon>
                    <div class="ml-2">
                      <h4>Result Assessment</h4>
                      <h4>Test IQ</h4>
                    </div>
                  </div>

                  <div>
                    <v-btn
                      icon
                      small
                      color="#016443"
                      @click="toDetail(item.data)"
                      ><v-icon> mdi-eye </v-icon>
                    </v-btn>
                  </div>
                </v-card>
                <div
                  v-if="
                    permissions.includes('LD') ||
                    permissions.includes('TEACHER')
                  "
                  class="d-flex justify-end px-3"
                >
                  <v-btn
                    dark
                    class="mt-2 text-capitalize"
                    color="#016443"
                    @click="item.isEdit = !item.isEdit"
                  >
                    <v-icon> mdi-pencil </v-icon>
                    Give
                    {{
                      role == "SUPERADMIN" ||
                      permissions.includes("LD") ||
                      permissions.includes("TEACHER")
                        ? "score and"
                        : ""
                    }}
                    note
                  </v-btn>
                </div>
                <div class="my-3 d-flex align-start jusitfy-center flex-column">
                  <h4>Score</h4>
                  <v-card
                    v-if="
                      role != 'SUPERADMIN' &&
                      !permissions.includes('LD') &&
                      !permissions.includes('TEACHER')
                    "
                    class="pa-2 px-5 d-flex align-center jusitfy-center"
                    outlined
                  >
                    <h4>{{ item.data.score }}</h4>
                    <h4 style="color: #a2aaad">/100</h4>
                  </v-card>
                  <div v-else>
                    <v-card
                      v-if="!item.isEdit"
                      class="pa-2 px-5 d-flex align-center jusitfy-center"
                      outlined
                    >
                      <h4>{{ item.data.score }}</h4>
                      <h4 style="color: #a2aaad">/100</h4>
                    </v-card>
                    <v-card
                      v-if="item.isEdit"
                      class="pa-2 my-2 d-flex align-center jusitfy-center"
                      outlined
                    >
                      <div class="d-flex align-center">
                        <input
                          type="number"
                          class="input_score"
                          v-model="item.data.score"
                        />
                        <h4 style="color: #a2aaad">/100</h4>
                      </div>
                    </v-card>
                  </div>
                </div>
                <div class="my-3">
                  <h4>Note</h4>
                  <v-textarea
                    :disabled="!item.isEdit"
                    hide-details
                    class="my-1 rounded-lg"
                    rows="4"
                    background-color="#f6f6f6"
                    solo
                    flat
                    placeholder="Type here..."
                    auto-grow
                    v-model="item.notes"
                  ></v-textarea>
                </div>

                <div v-if="item.isEdit">
                  <v-btn
                    color="#016443"
                    v-if="!sending"
                    @click="
                      updateData(
                        i,
                        item,
                        role != 'SUPERADMIN' &&
                          !permissions.includes('LD') &&
                          !permissions.includes('TEACHER'),
                      )
                    "
                  >
                    <h5 style="color: white">SEND</h5>
                  </v-btn>
                  <v-btn color="#016443" v-else>
                    <h5 style="color: white">Loading</h5>
                  </v-btn>
                </div>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
      <div class="empty" v-if="!loading && !dataSet.length">
        <v-card
          elevation="1"
          class="rounded-lg pa-3 my-3 align-center justify-center d-flex flex-column"
        >
          <img
            src="../../../../assets/img/redaksi/pagenotfound.png"
            height="150px"
            alt=""
          />
          <b class="default_txt my-3">Data not found</b>
        </v-card>
      </div>
    </div>
    <div v-if="loading">
      <v-card class="my-2 pa-3 rounded-lg" v-for="i in 3" :key="i">
        <v-skeleton-loader type="list-item-avatar"></v-skeleton-loader>
      </v-card>
    </div>
    <div class="text-center pa-3" v-if="dataSet">
      <v-pagination
        v-model="page"
        :color="color"
        @input="fetchData"
        :length="last_page"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "resultAssesment",
  props: ["color", "tools_id"],
  data() {
    return {
      dataSet: null,
      loading: false,
      sending: false,
      page: 1,
      limit: 10,
      total: null,
      last_page: null,
      find: "",
      notes: "",
      myNotes: null,
    };
  },
  mounted() {
    this.fetchData(true);
  },
  computed: {
    ...mapState({
      ava: (state) => state.ava,
      id: (state) => state.id,
      role: (state) => state.role,
      permissions: (state) => state.permissions,
    }),
  },
  methods: {
    exportData() {
      let body = {
        instance_id: this.$route.params.idInstance,
      };
      let data = {
        path: `manage/assessment/export`,
        body: body,
      };
      this.$store
        .dispatch("course/postApi", data)
        .then((data) => {
          location.href = data.data.path;
        })
        .catch((e) => {
          this.$toast.error(e.message);
        });
    },
    fetchData(first) {
      if (first) {
        this.loading = true;
      }
      let instance = this.$route.params.idInstance;
      let data = {
        path: `manage/course/section/assessment/result/${instance}?filter[search]=${this.find}&page[number]=${this.page}&page[size]=${this.limit}&include=dataTools,dataNotes`,
      };
      this.$store
        .dispatch("course/getData", data)
        .then((data) => {
          this.sending = false;
          if (data.data.length) {
            let tempData = [];
            let answer_id = [];
            data.data.forEach(async (item) => {
              item.score = item.score ? parseFloat(item.score) : 0;
              answer_id.push(item.answer_id);
              tempData.push(item);
            });
            this.getNotes(answer_id, tempData, data.total, data.last_page);
            this.$emit("empty", false);
          } else {
            this.$emit("empty", true);
          }
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.sending = false;
        });
    },
    async dataUniv(item, total, last_page) {
      await item.forEach((tempItem) => {
        tempItem.data.university_id = {
          id: tempItem.data.university_id,
          name: null,
        };
        if (tempItem.data.university_id.id) {
          let data = {
            path: `manage/univ/get?filter[id]=${tempItem.data.university_id.id}`,
          };
          this.$store
            .dispatch("user/getUser", data)
            .then((data) => {
              tempItem.data.university_id.name = data.data[0].name;
            })
            .catch((e) => {
              this.$store.dispatch("notify", {
                msg: e.message,
                type: "error",
              });
            });
        }
      });
      this.dataSet = item;
      this.total = total;
      this.last_page = last_page;
      this.loading = false;
    },
    async getNotes(item, dataSet, total, last_page) {
      let answer_id = [JSON.stringify(item)];
      let data = {
        path: `manage/course/section/assessment/notes?course_assessment_answer_id=${answer_id}&user_id=${this.id}`,
      };
      await this.$store
        .dispatch("course/getData", data)
        .then((data) => {
          if (data.length) {
            this.myNotes = data[0];
          }
          dataSet.forEach((item, idx) => {
            if (data.length > 0) {
              for (let i = 0; i < data.length; i++) {
                let same =
                  data[i].course_assessment_answer_id == item.answer_id;
                dataSet[idx] = {
                  data: item,
                  isEdit: false,
                  notes: same ? data[i].notes : "",
                };
                if (same) {
                  break;
                }
              }
            } else {
              dataSet[idx] = {
                data: item,
                isEdit: false,
                notes: "",
              };
            }
          });
        })
        .catch((e) => {
          dataSet.forEach((item, idx) => {
            dataSet[idx] = {
              data: item,
              isEdit: false,
              notes: "",
            };
          });
        });
      this.dataUniv(dataSet, total, last_page);
    },
    toDetail(item) {
      let instance = this.$route.params.idInstance;
      let course = this.$route.params.idCourse;
      let section = this.$route.params.idSection;
      let path = `/module/inclass/${section}/${course}/${instance}/${this.tools_id}/${item.id}/assessment`;
      this.$router.push(path);
    },
    async updateData(idx, item, scoreNotUpdate) {
      this.sending = true;
      if (!scoreNotUpdate) {
        await this.updateScore(item);
        await this.updateNotes(item, idx);
      } else {
        await this.updateNotes(item, idx);
      }
    },
    updateScore(item) {
      let body = {
        course_assessment_id: item.data.course_assessment_id,
        scholar_id: item.data.scholar_id,
        assessment_tools_id: item.data.assessment_tools_id,
        score: parseFloat(item.data.score).toFixed(1),
      };
      let data = {
        path: `manage/course/section/assessment/detail/score`,
        body: body,
      };
      this.$store
        .dispatch("course/postApi", data)
        .then((data) => {})
        .catch((e) => {
          this.$toast.error(e.message);
        });
    },
    updateNotes(item, idx) {
      let body = {
        course_assessment_answer_id: item.data.answer_id,
        notes: item.notes,
      };
      let data = {
        path: `manage/course/section/assessment/detail/notes`,
        body: body,
      };
      this.$store
        .dispatch("course/postApi", data)
        .then((data) => {
          this.notes = "";
          this.fetchData();
          this.dataSet[idx]["isEdit"] = false;
        })
        .catch((e) => {
          this.$toast.error(e.message);
        });
    },
  },
};
</script>

<style>
.strip-y {
  padding: 3px;
  width: 10px;
  max-height: 100%;
  border-radius: 0 !important;
}
.input_score {
  width: 50px;
}
.input_score:focus {
  outline: none;
}
</style>
